<template>
  <div class="calendar">
    <div class="container">
      <div class="c-header">
        <ol>
          <li><el-date-picker @change="changeYear" v-model="year" type="year" placeholder="选择年" :clearable="false" > </el-date-picker></li>
          <li><i class="el-icon-arrow-left" @click="prevDate"></i><el-select @change="changeMonth" v-model="month" placeholder="请选择"><el-option v-for="item in monthOptions" :key="item" :label="item" :value="item"></el-option></el-select><i class="el-icon-arrow-right" @click="nextDate"></i></li>
          <li v-if="title">宜{{title}}吉日在线查询</li>
          <li v-else>每日宜忌在线查询</li>
        </ol>
        <div style="display:flex">
        <div class="button" @click="reload">查看全部</div>
        <div class="button"><router-link to="/">返回首页</router-link></div>
        </div>
      </div>
      <div class="yi-body" v-show="cData.length > 0">
        <dl v-for="(item, index) in cData" :key="index">
          <dt><span>{{item.year}}<i>{{item.date}}</i></span><span>{{item.sx}}{{item.chou}}{{item.sha}}</span></dt>
          <dd><span><i>宜</i><i><em v-for="(items, index2) in item.yi" :key="index2" :class="items === title ? 'red' : ''">{{items}}</em></i></span><span><i>忌</i><i><em v-for="(items, index2) in item.ji" :key="index2">{{items}}</em></i></span></dd>
        </dl>
      </div>
      <div class="yi-body" v-show="cData.length === 0">
        <p>今日暂无关于{{title}}的信息</p>
       </div>
    </div>
    <footerCon></footerCon>
  </div>
</template>
<script>
import footerCon from "@/components/footer";
import {Solar, SolarWeek, Lunar, Foto} from 'lunar-typescript';
import yiji from '@/utils/yiji'
export default {
  components: {
    footerCon
  },
  data() {
    return {
      today: new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getDate(),
      year: new Date().getFullYear().toString(),
      month: new Date().getMonth() + 1 + '月',
      day:'',
      monthOptions:['1月','2月','3月','4月','5月','6月','7月','8月','9月','10月','11月','12月'],
      dataTime: new Date(),
      id: 1,
      title:'',
      daysInMonth: 0,
      cData:[],
      date:this.$route.query.date
    };
  },
  mounted(){
    this.initData()
  },
  methods: {
     removeLeadingZeros(str) {
        return str.replace(/^0+/, '');
    },
    //默认数据
    initData(){
      this.day =  new Date().getDate()
      if(this.date){
        this.year = this.date.split('-')[0]
        this.month = this.removeLeadingZeros(this.date.split('-')[1]) + '月'
      }
      this.dataTime = this.year + '-' + this.month.split('月')[0] + '-' + this.day
      this.today = this.dataTime
      this.date = null
      this.methodAll()
    },
    //方法合集
    methodAll(){
      this.getLastPathSegment()
      this.getDaysInMonth()
      this.getDayYiText()
      this.getDayJiText()
    },
    //获取链接id
    getUrlId() {
      const get_href = window.location.href;
      const get_indexof = get_href.lastIndexOf("/");
      const get_indexText = get_href.substring(get_indexof + 1);
      const get_htmlBeforeText = get_indexText;
      this.id = get_indexText.substring(0, get_htmlBeforeText);
       this.id = this.id.split('?') ? this.id.split('?')[0] : this.id
      const title = yiji.data.filter(items => items.id === Number(this.id))
      this.title = title.length > 0 ? title[0].name : ''
    },
    getLastPathSegment() {
      const url = window.location.href;
      const segments = url.split('/').filter(segment => segment);
      this.id = segments[segments.length - 1];
      this.id = this.id.split('?') ? this.id.split('?')[0] : this.id
      if(this.id === ''){
        this.id = segments[segments.length - 2];
        this.id = this.id.split('?') ? this.id.split('?')[0] : this.id
      }
      const title = yiji.data.filter(items => items.id === Number(this.id))
      this.title = title.length > 0 ? title[0].name : ''
    },
    //选择年份
    changeYear(e){
      this.year = new Date(e).getFullYear().toString()
      this.holiday = ''
      this.dataTime = new Date(e).getFullYear() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getDate()
      this.today = this.dataTime
      this.$router.push({
        path: '/yi/' + this.id + '?date=' + this.year + '-' + this.month.split('月')[0]
      });
      this.methodAll()
    },
    //选择月份
    changeMonth(){
      this.holiday = ''
      this.$router.push({
        path: '/yi/' + this.id + '?date=' + this.year + '-' + this.month.split('月')[0]
      });
      this.initData()
    },
    //上一个月
    prevDate(){
      if(this.month === '1月'){
        this.year = (Number(this.year) - 1).toString()
        this.month = '12月'
      }else{
        this.month = Number(this.month.split('月')[0]) - 1 + '月'
      }
      this.holiday = ''
      this.$router.push({
        path: '/yi/' + this.id + '?date=' + this.year + '-' + this.month.split('月')[0]
      });
      this.initData()
    },
    //下一个月
    nextDate(){
      if(this.month === '12月'){
        this.year = (Number(this.year) + 1).toString()
        this.month = '1月'
      }else{
        this.month = Number(this.month.split('月')[0]) + 1 + '月'
      }
      this.holiday = ''
      this.$router.push({
        path: '/yi/' + this.id + '?date=' + this.year + '-' + this.month.split('月')[0]
      });
      this.initData()
    },
    //获取日数
    getDaysInMonth() {
      const date = new Date(this.year, this.month.split('月')[0], 0); 
      this.daysInMonth = date.getDate();
    },
    //获取每日宜
    getDayYiText(){
      let cData = []
      for(let i=0; i<this.daysInMonth; i++){
        const today = this.year + '-' + this.month.split('月')[0] + '-' + (i+1)
        const d = Lunar.fromDate(new Date(today));
        let l = d.getDayYi();
        let arr = []
        for (let i=0, j=l.length; i<j; i++){
          arr.push(l[i])
        }
        cData.push({
          year: this.year + '年',
          date: this.month.split('月')[0] + '-' + (i+1),
          yi: arr
        })
      }
      this.cData = []
      for(let i=0; i<cData.length; i++){
        for(let j=0; j<cData[i].yi.length; j++){
          if(this.title){
            if(cData[i].yi[j] === this.title){
              this.cData.push(cData[i])
            }
          }else{
            this.cData.push(cData[i])
          }
        }
      }
      const newArr = new Map()
      this.cData = this.cData.filter((a) => !newArr.has(a.date) && newArr.set(a.date, 1))
    },
    //获取每日忌
    getDayJiText(){
      for(let i=0; i<this.cData.length; i++){
        const today = this.cData[i].year.split('年')[0] + '-' + this.cData[i].date
        const d = Lunar.fromDate(new Date(today));
        let l = d.getDayJi();
        let arr = []
        for (let i=0, j=l.length; i<j; i++){
          arr.push(l[i])
        }
        this.cData[i].ji = arr
        this.cData[i].sha = '煞' +  d.getSha()
        this.cData[i].sx = '冲' +  d.getChongDesc().split(')')[1]
        this.cData[i].chou = d.getChongDesc().split(')')[0] + ')'
        document.title =  this.year + '年' + this.month + '宜' + this.title + '吉日在线查询-' + window.g.title
        document.querySelector('meta[name="keywords"]').setAttribute('content', this.year + '年' + this.month + '宜' + this.title + '吉日在线查询');
        document.querySelector('meta[name="description"]').setAttribute('content', this.year + '年' + this.month + '有哪些日子是宜' + this.title + '的日子，中华老黄历网为大家提供' + this.title + '吉日在线查询！')
      }
    },
    reload(){
      window.location.href = '/yi'
    }
  }
};
</script>
<style lang="scss" scoped>
@font-face {
  font-family: "JingHuaLaoSongTi";
  font-weight: normal;
  src: url("../assets/aliyun/8m2D40dU62JY.woff2") format("woff2"),
  url("../assets/aliyun/8m2D40dU62JY.woff") format("woff");
  font-display: swap;
  font-style: normal;
}
.calendar * {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.calendar {
  .container {
    width: 100%;
    box-shadow: 0 2px 8px 0 rgba(0,0,0,.08);
    border-radius: 15px;
    margin: 0;
    box-sizing: border-box;
    // border: 2px solid #4E6EF2;
    overflow: hidden;
    .c-header {
      position: relative;
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 55px;
      padding: 12px;
      background: #eaecf2;
      overflow: hidden;
      ol{
        display: flex;
        align-items: center;
        li{
          display: flex;
          align-items: center;
          position: relative;
          margin-right: 10px;
          width: 240px;
          &:nth-child(3){
            font-size: 18px;
            font-weight: bold;
            color: #36f;
          }
          i{
            color: #888;
            font-size: 16px;
            cursor: pointer;
            margin: 0 3px;
            &:hover{
              color: #333;
            }
          }
        }
      }
      .button{
        height: 32px;
        line-height: 32px;
        text-align: center;
        background: #fff;
        border-radius: 6px;
        color: #333;
        cursor: pointer;
        font-size: 13px;
        padding: 0 12px;
        margin-left: 12px;
        &:hover{
          color: #0f9fff;
          opacity: .75;
        }
      }
    }
  }
}
.yi-body{
  padding: 20px;
  dl{
    display: flex;
    color: #fff;
    font-size: 16px;
    margin: 10px 0 30px;
    dt{
      display: flex;
      justify-content: center;
      align-items: center;
      flex-wrap: wrap;
      flex-shrink: 0;
      object-fit: cover;
      background: url(../assets/day.png) no-repeat;
      width: 128px;
      height: 152px;
      text-align: center;
      padding: 38px 0;
      box-sizing: border-box;
      margin-right: 20px;
      span{
        display: block;
        flex-basis: 100%; 
        i{
          display: block;
          width: 100%;
          font-size: 38px;
        }
      }
    }
    dd{
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      font-size: 16px;
      padding: 30px 10px;
      span{
        display: flex;
        color: #333;
        flex-basis: 100%; 
        i{
          padding: 1px 2px 0;
          border-radius: 3px;
          margin-right: 8px;
        }
        &:nth-child(1) i:nth-child(1){
          border: 1px solid #36f;
          color: #36f;
          height: 26px;
        }
        &:nth-child(2) i:nth-child(1){
          border: 1px solid #eb3333;
          color: #eb3333;
          height: 26px;
        }
        em{
          margin: 0 4px;
          &.red{
            color: red;
          }
          &.blue{
            color: #36f;
          }
        }
      }
    }
  }
  p{
    text-align: center;
    color: #999;
    height: 75vh;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
  }
}
@media screen and (max-width: 1000px) {
  .calendar .container .c-header ol li{
    width: 160px;
  }
  .calendar .container .c-header ol li:nth-child(3){
    display: none;
  }
  .c-header div.button{
    display: none!important;
  }
  .yi-body{
    padding:8px 0 8px 8px;
    dl{
      display: block;
      dt{
        margin: 0 auto;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/Yi.vue